module.exports = __webpack_public_path__ + "img/paperclip.eab38ca2.svg";